import React from 'react';
import PropTypes from 'prop-types';
import _classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import Popper from '@material-ui/core/Popper';
import Typography from '@material-ui/core/Typography';
import _find from 'lodash/find';
import ArrowUp from 'containers/Topic/images/arrow-up-gray.svg';
import ArrowDown from 'containers/Topic/images/arrow-down-gray.svg';
import DropDownMenu from './DropDownMenu';
import TypeSelector from './TypeSelector';

const styles = theme => ({
  root: {
    width: '100%',
    padding: '20px 5%',
  },
  selectedTypesRoot: {
    height: 45,
    width: '100%',
    position: 'relative',
    border: '1px solid #E9ECED',
    borderRadius: 2,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    padding: '0 8px',
    overflow: 'hidden',
  },
  disabled: {
    cursor: 'default',
  },
  sortText: {
    color: '#A6A6A6',
    ...theme.typography.pxSmall,
    marginRight: 5,
  },
  selectedSortText: {
    ...theme.typography.pxSmall,
    width: 96,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  arrowIcon: {
    position: 'absolute',
    right: 5,
    [theme.breakpoints.down('991')]: {
      right: 15,
    },
  },
  selectedIcon: {
    margin: '0 10px',
  },
});

class ResourcesTypeSelector extends React.Component {
  state = {
    anchorEl: null,
    anchorWidth: null,
  };

  handleClick = event => {
    const { currentTarget } = event;
    this.setState(state => ({
      anchorEl: state.anchorEl ? null : currentTarget,
    }));
  };

  componentDidMount() {
    this.setState({
      anchorWidth: this.menuBlock.clientWidth,
    });
  }

  changeSortFilter = item => {
    this.setState(
      {
        anchorEl: null,
      },
      () => {
        this.props.clickHandler(item);
      },
    );
  };

  render() {
    const { classes, options, activeTab } = this.props;
    const { anchorEl, anchorWidth } = this.state;
    const open = Boolean(anchorEl);
    const id = open ? 'menu-popper' : null;
    const selectedSort = _find(options, { label: activeTab });
    /*eslint-disable*/
    return (
      <div className={classes.root}>
        <div
          className={_classNames({
            [classes.selectedTypesRoot]: true,
          })}
          role="button"
          aria-describedby={id}
          onClick={this.handleClick}
          ref={ref => {
            this.menuBlock = ref;
          }}
        >
          <Typography className={classes.sortText}>Show:</Typography>
          <img
            src={selectedSort.icon[1]}
            alt="Selected Icon"
            className={classes.selectedIcon}
          />
          <Typography color="textPrimary" className={classes.selectedSortText}>
            {selectedSort.label}
          </Typography>
          <img
            src={open ? ArrowUp : ArrowDown}
            className={classes.arrowIcon}
            alt="arrow"
          />
        </div>
        <Popper
          id={id}
          open={open}
          anchorEl={anchorEl}
          placement="bottom-start"
        >
          <DropDownMenu width={anchorWidth}>
            <TypeSelector
              onChange={this.changeSortFilter}
              selectedValue={activeTab}
              data={options}
            />
          </DropDownMenu>
        </Popper>
      </div>
    );
  }
}

ResourcesTypeSelector.propTypes = {
  onChange: PropTypes.func,
  options: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  activeTab: PropTypes.string,
  clickHandler: PropTypes.func,
  classes: PropTypes.object,
};

export default withStyles(styles)(ResourcesTypeSelector);
